import { t } from "@lingui/macro";
import { useAtomValue } from "jotai";

import { getMemberBookingRoundsAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getBookingRounds/getBookingMemberRounds";
import { Text } from "@whoosh/design-system/src/components/primitive";

const isValidMember = (player: {
  clientType: string;
  firstName?: string | null;
  lastName?: string | null;
}): player is { clientType: "member"; firstName: string; lastName: string } => {
  return (
    player.clientType === "member" && !!player.firstName && !!player.lastName
  );
};

type Props = {
  hostId: string;
};

export const HostingMemberDisplay = ({ hostId }: Props) => {
  const memberBookingRounds = useAtomValue(getMemberBookingRoundsAtom);

  const hostingMember = memberBookingRounds.find(
    (round) => round.player.id === hostId
  );

  const hostingMemberOptions = memberBookingRounds
    .map((round) => {
      if (isValidMember(round.player)) {
        return {
          label: `${round.player.firstName} ${round.player.lastName}`,
          value: round.player.id,
        };
      }
      return undefined;
    })
    .filter(
      (option): option is { label: string; value: string } =>
        option !== undefined
    );

  // If hostingMember is undefined, use the last one from hostingMemberOptions
  const effectiveHostingMember =
    hostingMember ??
    (hostingMemberOptions.length > 0
      ? memberBookingRounds.find(
          (round) =>
            round.player.id ===
            hostingMemberOptions[hostingMemberOptions.length - 1].value
        )
      : undefined);

  return (
    <>
      <Text variant="mainTiny" color="text-secondary">{t`Hosting Member`}</Text>
      <Text variant="mainSmallSemiBold" color="text-primary">
        {effectiveHostingMember?.player.clientType === "member" &&
        effectiveHostingMember?.player.firstName &&
        effectiveHostingMember?.player.lastName
          ? `${effectiveHostingMember?.player.firstName} ${effectiveHostingMember?.player.lastName}`
          : t`Unknown Member`}
      </Text>
    </>
  );
};
